export default {
  statusApproved: 'Aprobada',
  statusBlockedNatura: 'Bloqueada',
  statusDraft: 'En proceso de registro',
  statusGaveup: 'Desistencia',
  statusPending: 'En proceso de registro',
  statusRejected: 'Reprobada',
}
